import React from 'react';
import { Stat, StatType } from '@amzn/stencil-react-components/data-visualization';
import { useTranslation } from 'react-i18next';

interface FeedbackStatProps {
  feedbacks: number|undefined;
}

export const FeedbackStat = (props: FeedbackStatProps) => {
  const { t } = useTranslation();

  const count = props.feedbacks || 0;
  return (
    <Stat
      type={StatType.Large}
      numeralText={count.toString()}
      descriptionText={count == 1 ? t('feedback') : t('feedbacks')}
    />
  )
}